import { useCallback, useMemo, useState } from 'react';
import { useConfig, useDisconnect as useWagmiDisconnect } from 'wagmi';

import { RECENT_CONNECTOR_KEY, RECONNECT_KEY } from '../../../constants';

export const useDisconnect = () => {
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const { storage } = useConfig();
  const { disconnectAsync: wagmiDisconnectAsync, isPending } = useWagmiDisconnect();

  const computedIsDisconnecting = useMemo(() => isDisconnecting || isPending, [isDisconnecting, isPending]);

  const disconnectAsync = useCallback(
    async (...args: Parameters<typeof wagmiDisconnectAsync>) => {
      if (computedIsDisconnecting) {
        return;
      }

      await wagmiDisconnectAsync(...args);

      if (!storage) {
        return;
      }

      await Promise.all([storage.removeItem(RECENT_CONNECTOR_KEY), storage.removeItem(RECONNECT_KEY)]);

      setIsDisconnecting(false);
    },
    [wagmiDisconnectAsync, storage, computedIsDisconnecting],
  );

  return useMemo(
    () => ({ disconnectAsync, isDisconnecting: computedIsDisconnecting }),
    [disconnectAsync, computedIsDisconnecting],
  );
};
